import axios from "axios";
import { adnPageSize } from "../components/common/GeneralConfigurations";
import {
  baseApiUrl,
  getHttpHeaders,
  getHttpHeadersExcel,
  httpRequest,
} from "./ApiUtils";

const employeeFollowUpEventApiUrl = `${baseApiUrl}/api/EmployeeFollowUpEvent`;
const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export async function getEmployeeFollowUpEventById(id) {
  return await httpRequest(fetchEmployeeFollowUpEventById.bind(this, id));
}
async function fetchEmployeeFollowUpEventById(id) {
  let config = getHttpHeaders();
  return await axios.get(`${employeeFollowUpEventApiUrl}/${id}`, config);
}

export async function getEmployeeFollowUpEventList(
  pageNumber = 1,
  orderBy = "",
  eventType = "",
  employee = "",
  doneBy = "",
  done,
  month = "",
  year = ""
) {
  return await httpRequest(
    fetchEmployeeFollowUpEvents.bind(
      this,
      pageNumber,
      adnPageSize,
      orderBy,
      eventType,
      employee,
      doneBy,
      done ?? "",
      month,
      year
    )
  );
}
async function fetchEmployeeFollowUpEvents(
  pageNumber,
  pageSize,
  orderBy,
  eventType,
  employee,
  doneBy,
  done,
  month,
  year
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}?pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&eventTypeName=${eventType}&employeeName=${employee}&userName=${doneBy}&done=${done}&Month=${month}&Year=${year}`,
    config
  );
}

export async function getEmployeeFollowUpEventListByEmployee(
  searchEmployee,
  eventType,
  userName,
  followUpEventDone,
  followUpEventMonth,
  followUpEventYear,
  orderBy,
  currPage,
  adnPageSize
) {
  return await httpRequest(
    fetchEmployeeFollowUpEventListByEmployee.bind(
      this,
      searchEmployee,
      eventType ?? "",
      userName,
      followUpEventDone ?? "",
      followUpEventMonth,
      followUpEventYear,
      orderBy,
      currPage,
      adnPageSize
    )
  );
}

async function fetchEmployeeFollowUpEventListByEmployee(
  searchEmployee,
  eventType,
  userName,
  followUpEventDone,
  followUpEventMonth,
  followUpEventYear,
  orderBy,
  currPage,
  adnPageSize
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/Employee?Name=${searchEmployee}&EventTypeName=${eventType}&UserName=${userName}&Done=${followUpEventDone}&Month=${followUpEventMonth}&Year=${followUpEventYear}&OrderBy=${orderBy}&PageNumber=${currPage}&PageSize=${adnPageSize}`,
    config
  );
}

export async function addEmployeeFollowUpEvent(followUpEvent) {
  return await httpRequest(postEmployeeFollowUpEvent.bind(this, followUpEvent));
}

async function postEmployeeFollowUpEvent(followUpEvent) {
  let config = getHttpHeaders();
  return await axios.post(
    `${employeeFollowUpEventApiUrl}`,
    followUpEvent,
    config
  );
}

export async function updateEmployeeFollowUpEvent(followUpEvent) {
  return await httpRequest(putEmployeeFollowUpEvent.bind(this, followUpEvent));
}

async function putEmployeeFollowUpEvent(followUpEvent) {
    let config = getHttpHeaders();
  return await axios.put(
    `${employeeFollowUpEventApiUrl}`,
    followUpEvent,
    config
  );
}

export async function getFollowUpEventByEmployeeId(
  id,
  orderBy = "",
  pageNumber = 1
) {
  return await httpRequest(
    fetchFollowUpEventByEmployeeId.bind(
      this,
      id,
      orderBy,
      pageNumber,
      adnPageSize
    )
  );
}
async function fetchFollowUpEventByEmployeeId(
  id,
  orderBy,
  pageNumber,
  adnPageSize
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/Employee/${id}?EmployeeId=${id}&OrderBy=${orderBy}&PageNumber=${pageNumber}&PageSize=${adnPageSize}`,
    config
  );
}

export async function getFollowUpEventsStatus(
  startDate,
  endDate,
  doneById = "",
  doneByName = "",
  eventTypeId = ""
) {
  return await httpRequest(
    fetchFollowUpEventsStatus.bind(
      this,
      startDate,
      endDate,
      doneById,
      doneByName,
      eventTypeId
    )
  );
}
async function fetchFollowUpEventsStatus(
  startDate,
  endDate,
  doneById,
  doneByName,
  eventTypeId
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/Status?StartDate=${startDate}&EndDate=${endDate}&DoneById=${doneById}&DoneByName=${doneByName}&EventTypeId=${eventTypeId}`,
    config
  );
}

export async function getEmployeesSatisfactionLevels(employeeId = EMPTY_GUID) {
  return await httpRequest(
    fetchEmployeesSatisfactionLevels.bind(this, employeeId)
  );
}
async function fetchEmployeesSatisfactionLevels(employeeId) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/StatisfactionLevels?EmployeeId=${employeeId}`,
    config
  );
}

export async function getUserEmployeeFollowUpEventsCounter(month, year) {
  return await httpRequest(
    fetchUserEmployeeFollowUpEventsCounter.bind(this, month, year)
  );
}

async function fetchUserEmployeeFollowUpEventsCounter(month, year) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/User?Month=${month}&Year=${year}`,
    config
  );
}

export async function getEmployeeFollowUpEventsCounters(id) {
  return await httpRequest(fetchEmployeeFollowUpEventsCounters.bind(this, id));
}

async function fetchEmployeeFollowUpEventsCounters(id) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/Counters?EmployeeId=${id}`,
    config
  );
}

export async function getEmployeeFollowUpEventStatistics(month, year) {
  return await httpRequest(
    fetchEmployeeFollowUpEventStatistics.bind(this, month, year)
  );
}

async function fetchEmployeeFollowUpEventStatistics(month, year) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/Statistics?Month=${month}&Year=${year}`,
    config
  );
}

export async function getEmployeeStatisfactionLevelsDetails(
  lastDays = "",
  satisfied = true,
  limit = "",
  type = ""
) {
  return await httpRequest(
    fetchEmployeeStatisfactionLevelsDetails.bind(
      this,
      lastDays,
      satisfied,
      limit,
      type
    )
  );
}

async function fetchEmployeeStatisfactionLevelsDetails(
  lastDays,
  satisfied,
  limit,
  type
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/StatisfactionLevelsDetails?LastDays=${lastDays}&Satisfied=${satisfied}&Limit=${limit}&Type=${type}`,
    config
  );
}

export async function generateAnnualReport() {
  return await httpRequest(fetchAnnualReportGenerateExcel.bind(this));
}
async function fetchAnnualReportGenerateExcel() {
  let config = getHttpHeadersExcel();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/GenerateAnnualReportExcel?`,
    config
  );
}

export async function getOverdueFollowupEventsReport() {
  return await httpRequest(fetchOverdueFollowupEventsExcel.bind(this));
}
async function fetchOverdueFollowupEventsExcel() {
  let config = getHttpHeadersExcel();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/OverdueEvents`,
    config
  );
}

export async function getWelcomeReport() {
  return await httpRequest(fetchWelcomeSessionFollowupEventsExcel.bind(this));
}
async function fetchWelcomeSessionFollowupEventsExcel() {
  let config = getHttpHeadersExcel();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/WelcomeSession`,
    config
  );
}

export async function getEmployeeFollowUpEventsByDate(
  month,
  year,
  orderBy = "",
  pageSize = adnPageSize,
  pageNumber = 1,
  employeeName = "",
  assignedToName = "",
  managerName = "",
  eventType = null,
  eventStatus = -1,
  contractType = null,
  userID = 0
) {
  return await httpRequest(
    fetchEmployeeFollowUpEventsByDate.bind(
      this,
      month,
      year,
      orderBy,
      pageSize,
      pageNumber,
      employeeName,
      assignedToName,
      managerName,
      eventType,
      contractType,
      eventStatus,
      userID
    )
  );
}

async function fetchEmployeeFollowUpEventsByDate(
  month,
  year,
  orderBy,
  pageSize,
  pageNumber,
  employeeName,
  assignedToName,
  managerName,
  eventType,
  contractType,
  eventStatus,
  userID
) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/Date?Month=${month}&Year=${year}&OrderBy=${orderBy}&PageSize=${pageSize}&pageNumber=${pageNumber}&EmployeeName=${employeeName}&AssignedToName=${assignedToName}&ManagerName=${managerName}&EventType=${eventType}&&contractType=${contractType}&EventStatus=${eventStatus}&UserID=${userID}`,
    config
  );
}

export async function getEmployeeFollowUpEventsByDateAndStatusCounter(
  month,
  year,
  status
) {
  return await httpRequest(
    fetchEmployeeFollowUpEventsByDateAndStatusCounter.bind(
      this,
      month,
      year,
      status
    )
  );
}

async function fetchEmployeeFollowUpEventsByDateAndStatusCounter(
  month,
  year,
  status
) {
  let config = getHttpHeaders();
  let url = `${employeeFollowUpEventApiUrl}/DateCounter?Month=${month}&Year=${year}`;
  if (Array.isArray(status)) {
    status.forEach((id) => {
      url += `&Status=${id}`;
    });
  } else if (status !== undefined) {
    url += `&Status=${status}`;
  }
  return await axios.get(url, config);
}

export async function checkPreviousUnresolvedEmployeeFollowUpEventsById(id) {
  return await httpRequest(
    fetchPreviousUnresolvedEmployeeFollowUpEventsById.bind(this, id)
  );
}

async function fetchPreviousUnresolvedEmployeeFollowUpEventsById(id) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/UnresolvedEvents?Id=${id}`,
    config
  );
}

export async function generateEvents() {
  return await httpRequest(getGenerateEvents.bind(this));
}

async function getGenerateEvents() {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/GenerateEvents`,
    config
  );
}

export async function assignToSupervisor(employeeFollowUpEventId) {
  return await httpRequest(
    putAssignToSupervisor.bind(this, employeeFollowUpEventId)
  );
}

async function putAssignToSupervisor(employeeFollowUpEventId) {
  let config = getHttpHeaders();
  return await axios.put(
    `${employeeFollowUpEventApiUrl}/SkipStatus`,
    employeeFollowUpEventId,
    config
  );
}

export async function notifyAssignPeople() {
  return await httpRequest(postNotifyAssignPeople.bind(this));
}
async function postNotifyAssignPeople() {
  let config = getHttpHeaders();
  return await axios.post(
    `${employeeFollowUpEventApiUrl}/NotifyAssignedPeople`,
    null,
    config
  );
}

export async function updateEmployeeFollowUpEventNotes(employeeFollowUpEvent) {
  return await httpRequest(
    patchUpdateEmployeeFollowUpEventNotes.bind(this, employeeFollowUpEvent)
  );
}
async function patchUpdateEmployeeFollowUpEventNotes(employeeFollowUpEvent) {
  let config = getHttpHeaders();
  return await axios.patch(
    `${employeeFollowUpEventApiUrl}`,
    employeeFollowUpEvent,
    config
  );
}

export async function getConsultantSatisfactionLevel(token) {
  return await httpRequest(fetchEmployeeFollowUpEventByToken.bind(this, token));
}
async function fetchEmployeeFollowUpEventByToken(token) {
  let config = getHttpHeaders();
  return await axios.get(
    `${employeeFollowUpEventApiUrl}/satisfactionlevel/${token}`,
    config
  );
}

export async function updateSatisfactionLevel(data) {
  return await httpRequest(patchSatisfactionLevel.bind(this, data));
}
async function patchSatisfactionLevel(data) {
  let config = getHttpHeaders();
  return await axios.patch(
    `${employeeFollowUpEventApiUrl}/SatisfactionLevel`,
    data,
    config
  );
}
